import { render, staticRenderFns } from "./KoioteValueLabelWrite.vue?vue&type=template&id=2c921298&lang=es"
import script from "./KoioteValueLabelWrite.vue?vue&type=script&lang=js"
export * from "./KoioteValueLabelWrite.vue?vue&type=script&lang=js"
import style0 from "./KoioteValueLabelWrite.vue?vue&type=style&index=0&id=2c921298&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports